import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Person = ({ width, className }) => (
  <svg
    width={width}
    height={width}
    className={cn(className, 'svg-inline--fa fa-th-large fa-w-16 fa-7x')}
    viewBox="0 0 512 512"
  >
    <path fill="currentColor" d="M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm240-16v176H32V80c0-8.837 7.163-16 16-16h192zM32 432V272h208v176H48c-8.837 0-16-7.163-16-16zm240 16V272h208v160c0 8.837-7.163 16-16 16H272zm208-208H272V64h192c8.837 0 16 7.163 16 16v160z" />
  </svg>
);

Person.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

Person.defaultProps = {
  width: 53,
  className: '',
};

export default Person;



// WEBPACK FOOTER //
// ./src/components/Icons/Table.js